module.exports = __webpack_public_path__ + "static/media/bars-white.02f91733.svg";